@let locationNamesValue = locationNames();

@if (locationNamesValue) {
  @if (isBadge()) {
    <rt-badge [color]="'secondary'" [contentTpl]="badgeContent" />
  } @else {
    <div layout-centered-y>
      @if (showIcon()) {
        <rt-icon name="place" size="small-x" margin-right-small-xx />
      }
      <ng-container *ngTemplateOutlet="locationsText" />
    </div>
  }
}

<ng-template #locationsText>
  @if (locationNamesValue.length === 1) {
    <span
      #locationTextRef
      [rtTooltip]="locationNamesValue[0]"
      [rtTooltipPosition]="tooltipPosition()"
      [rtTooltipEnabled]="isTruncatedFactory | fnCall: locationTextRef"
      class="location-text"
    >
      {{ locationNamesValue[0] }}
    </span>
  } @else {
    <span
      [rtTooltip]="tooltipPrefix() + locationNamesValue.join(', ')"
      [rtTooltipPosition]="tooltipPosition()"
      class="location-text"
    >
      {{ locationNamesValue.length }}
      {{ 'app.plurals.location' | translate: { count: locationNamesValue.length } }}
    </span>
  }
</ng-template>

<ng-template #badgeContent>
  <div class="badge-wrapper">
    @if (showIcon()) {
      <rt-icon name="place" size="small-xx" margin-right-small-xx />
    }
    <ng-container *ngTemplateOutlet="locationsText" />
  </div>
</ng-template>
